var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.agree()}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('span',[_vm._v("\n    "+_vm._s(_vm.$l.termsAndConditionsAgreement)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }